import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("Rttv-Tracking-Widget") as HTMLElement
);
root.render(
  <App />
);
